import { styled } from "stitches.config";
import Typography from "../sushi/Typography";
import { FormattedMessage, useIntl } from "react-intl";
import { getFormattedValue } from "@/utils/simulators";

export type MonthlyPaymentsResultValuesProps = {
  monthlyPayments: number;
  loanTotalCost: number;
  insurancePerMonth: number;
  insuranceTotalCost: number;
  isInvalid?: boolean;
}

export const MonthlyPaymentsResultValues = ({ monthlyPayments, insurancePerMonth, insuranceTotalCost, loanTotalCost, isInvalid }: MonthlyPaymentsResultValuesProps) => {
    const { formatMessage } = useIntl();

    return (
      <ResultValuesContainer>
        <div>
          <Typography variant="bodyS" color="secondary">
            {formatMessage({id: 'monthly_payments_simulator.result.monthly_payments'})}
          </Typography>
          <Typography variant="headingS" color="primary">
            {getFormattedValue(monthlyPayments, isInvalid)}
          </Typography>
          <Typography color="secondary" variant="bodyM">
            <FormattedMessage
              id="monthly_payments_simulator.result.monthly_insurance"
              values={{
                // @ts-expect-error
                cost: () => <Typography as="span" color="secondary">{getFormattedValue(insurancePerMonth, isInvalid)}</Typography>,
              }}
              />
          </Typography>
        </div>
        <SubValuesContainer>
          <ValueContainer>
            <Typography variant="bodyS" color="secondary">
              {formatMessage({id: 'monthly_payments_simulator.result.loan_total_cost'})}
            </Typography>
            <Typography variant="bodyS" color="primary" weight="medium">
              {getFormattedValue(loanTotalCost, isInvalid)}
            </Typography>
          </ValueContainer>
          <ValueContainer>
            <Typography variant="bodyS" color="secondary">
              {formatMessage({id: 'monthly_payments_simulator.result.insurance_total_cost'})}
            </Typography>
            <Typography variant="bodyS" color="primary" weight="medium">
              {getFormattedValue(insuranceTotalCost, isInvalid)}
            </Typography>
          </ValueContainer>
        </SubValuesContainer>
      </ResultValuesContainer>
    )
}

const ResultValuesContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$6',
  });

  const SubValuesContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$2',
    padding: '0 $10',
  });

  const ValueContainer = styled('div', {
    display: 'flex',
    flexDirection:' row',
    alignItems: 'center',
    justifyContent: 'space-between',
  });
